import { useState } from "react";
import { toast } from "sonner";
import { Copy, Link2, MessageCircle, Mail, MessageSquare, Send, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { copyText, trackingLink, waPhone } from "@/lib/format";

const btn = "inline-flex items-center justify-center gap-2 border px-3 py-2.5 text-xs font-semibold uppercase tracking-wider transition-colors";

export const SharePanel = ({ shipment }) => {
  const [sending, setSending] = useState(false);
  const link = trackingLink(shipment.code);
  const text = `Gentile ${shipment.recipient_name}, la sua spedizione LINCESSO GROUP TRASPORTI ha codice ${shipment.code}. Può seguirla qui: ${link}`;
  const phone = waPhone(shipment.recipient_phone);
  const email = shipment.recipient_email;

  const sendSystemEmail = async () => {
    setSending(true);
    try {
      await api.post(`/admin/shipments/${shipment.code}/send-email`);
      toast.success(`Email inviata a ${email}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-[#0B0C0E] text-white p-5 sm:p-6" data-testid="share-panel">
      <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#E50914]">Codice tracking</p>
      <div className="mt-2 flex flex-wrap items-center gap-3">
        <span className="font-mono text-2xl sm:text-3xl font-bold tracking-wider" data-testid="share-code">{shipment.code}</span>
      </div>
      <div className="mt-4 flex items-center gap-2 bg-white/5 border border-white/10 px-3 py-2">
        <Link2 className="h-4 w-4 text-slate-400 shrink-0" />
        <span className="text-xs sm:text-sm text-slate-300 truncate font-mono" data-testid="share-link">{link}</span>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2">
        <button onClick={() => copyText(shipment.code, "Codice copiato")} className={`${btn} bg-[#E50914] border-[#E50914] hover:bg-[#C10710]`} data-testid="copy-code-btn"><Copy className="h-4 w-4" /> Copia codice</button>
        <button onClick={() => copyText(link, "Link copiato")} className={`${btn} border-white/20 hover:border-white`} data-testid="copy-link-btn"><Link2 className="h-4 w-4" /> Copia link</button>
        <a href={`https://wa.me/${phone}?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer" className={`${btn} border-white/20 hover:border-emerald-400 hover:text-emerald-300`} data-testid="share-whatsapp-btn"><MessageCircle className="h-4 w-4" /> WhatsApp</a>
        <a href={`sms:${shipment.recipient_phone || ""}?body=${encodeURIComponent(text)}`} className={`${btn} border-white/20 hover:border-white`} data-testid="share-sms-btn"><MessageSquare className="h-4 w-4" /> SMS</a>
        <a href={`mailto:${email || ""}?subject=${encodeURIComponent(`Spedizione ${shipment.code}`)}&body=${encodeURIComponent(text)}`} className={`${btn} border-white/20 hover:border-white`} data-testid="share-mailto-btn"><Mail className="h-4 w-4" /> Email (app)</a>
        <button onClick={sendSystemEmail} disabled={!email || sending} className={`${btn} border-white/20 hover:border-white disabled:opacity-40 disabled:cursor-not-allowed`} title={email ? "" : "Nessuna email del destinatario"} data-testid="share-system-email-btn">
          {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Invia email
        </button>
      </div>
      <p className="mt-3 text-[11px] text-slate-500">WhatsApp, SMS ed Email (app) aprono l'app del tuo dispositivo con il messaggio già pronto. "Invia email" spedisce direttamente dal sistema.</p>
    </div>
  );
};
